import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

import type { CardBrand } from './billing.interface'
import { BillingCardBrandIcon } from './billing-card-brand-icon.atom'

export interface BillingCardDisplayProps {
  brand: CardBrand
  last4: string
  className?: string
}

const BillingCardDisplayBase: React.FC<BillingCardDisplayProps> = ({
  brand,
  last4,
  className,
}): ReactNode => (
  <div className={cn('billing-card-display flex items-center gap-2', className)}>
    <BillingCardBrandIcon brand={brand} size="sm" />
    <span className="capitalize">{brand}</span>
    <span>****{last4}</span>
  </div>
)

export const BillingCardDisplay = memo(BillingCardDisplayBase)

BillingCardDisplay.displayName = 'BillingCardDisplay'
